import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { aboutCompany } from '../data/mock';
import useScrollAnimation from '../hooks/useScrollAnimation';

const AboutCompany = () => {
  const [ref, isVisible] = useScrollAnimation({ threshold: 0.1 });

  return (
    <section ref={ref} className={`py-16 bg-white fade-in-up ${isVisible ? 'visible' : ''}`}>
      <div className="pp-container">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          {/* Right side - Text Content */}
          <div className="space-y-6">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
              {aboutCompany.title}
            </h2>
            <p className="text-gray-600 leading-relaxed text-lg">
              {aboutCompany.description}
            </p>
            <div className="grid grid-cols-2 gap-6 mt-8">
              {aboutCompany.features.map((feature, index) => (
                <div key={index} className="space-y-2">
                  <div className="flex items-start gap-3">
                    <CheckCircle2 className="w-6 h-6 text-[#005bbb] flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="font-semibold text-gray-900">{feature.title}</h3>
                      <p className="text-sm text-gray-600">{feature.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Left side - Visual Elements */}
          <div className="relative">
            <div className="grid grid-cols-2 gap-4">
              <div className="aspect-square bg-gradient-to-br from-[#005bbb] to-[#0077dd] rounded-2xl opacity-10"></div>
              <div className="aspect-square bg-gradient-to-br from-gray-300 to-gray-400 rounded-2xl opacity-10 mt-8"></div>
              <div className="aspect-square bg-gradient-to-br from-gray-300 to-gray-400 rounded-2xl opacity-10 -mt-8"></div>
              <div className="aspect-square bg-gradient-to-br from-[#005bbb] to-[#0077dd] rounded-2xl opacity-10"></div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="bg-white rounded-2xl shadow-2xl p-8 border border-gray-200">
                <div className="text-center space-y-4">
                  <div className="text-5xl font-bold text-[#005bbb]">+15</div>
                  <p className="text-gray-600 font-medium">سال تجربه</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutCompany;